import type {
  UserClientDto,
  UserClientViewDto,
  UserClientCarrierDto,
  UserClientCountryDto,
  UserClientDimensionDto,
  UserClientServiceGroupDto,
  UserClientZipZoneDto,
} from '@/api/models/types'
import { tryFetch } from '@/modules/services/http'
import { HttpMethod } from '@/modules/services/http/types/http.enums'
import type { UserClientAction } from '../models/user.models'

const BASE_URL = import.meta.env.VITE_MAIN_BASE_URL

const getUserClients = async (): Promise<{ data?: UserClientDto[]; error?: any; status: number }> =>
  await tryFetch(HttpMethod.Get, BASE_URL, ['users', 'me', 'clients'])

const getUserClientViews = async (
  clientKey: string,
  userId?: number,
): Promise<{ data?: UserClientViewDto[]; error?: any; status: number }> =>
  await tryFetch(HttpMethod.Get, BASE_URL, ['users', userId ?? 'me', 'clients', clientKey, 'views'])

const getUserClientActions = async (
  clientKey: string,
  userId?: number,
): Promise<{ data?: UserClientAction[]; error?: any; status: number }> =>
  await tryFetch(HttpMethod.Get, BASE_URL, [
    'users',
    userId ?? 'me',
    'clients',
    clientKey,
    'actions',
  ])

const getUserClientCarriers = async (
  clientKey: string,
  userId?: number,
): Promise<{ data?: UserClientCarrierDto[]; error?: any; status: number }> =>
  await tryFetch(HttpMethod.Get, BASE_URL, [
    'users',
    userId ?? 'me',
    'clients',
    clientKey,
    'carriers',
  ])

const getUserClientCountries = async (
  clientKey: string,
  userId?: number,
): Promise<{ data?: UserClientCountryDto[]; error?: any; status: number }> =>
  await tryFetch(HttpMethod.Get, BASE_URL, [
    'users',
    userId ?? 'me',
    'clients',
    clientKey,
    'countries',
  ])

const getUserClientDimension = async (
  clientKey: string,
  id: number,
  userId?: number,
): Promise<{ data?: UserClientDimensionDto[]; error?: any; status: number }> =>
  await tryFetch(
    HttpMethod.Get,
    BASE_URL,
    ['users', userId ?? 'me', 'clients', clientKey, 'dimension'],
    {
      queryParams: {
        number: id,
      },
    },
  )

const getUserClientServiceGroups = async (
  clientKey: string,
  userId?: number,
): Promise<{ data?: UserClientServiceGroupDto[]; error?: any; status: number }> =>
  await tryFetch(HttpMethod.Get, BASE_URL, [
    'users',
    userId ?? 'me',
    'clients',
    clientKey,
    'service-groups',
  ])

const getUserClientZipZones = async (
  clientKey: string,
  userId?: number,
): Promise<{ data?: UserClientZipZoneDto[]; error?: any; status: number }> =>
  await tryFetch(HttpMethod.Get, BASE_URL, [
    'users',
    userId ?? 'me',
    'clients',
    clientKey,
    'zip-zones',
  ])

export const userClientApi = {
  getUserClients,
  getUserClientViews,
  getUserClientActions,
  getUserClientCarriers,
  getUserClientCountries,
  getUserClientDimension,
  getUserClientServiceGroups,
  getUserClientZipZones,
}
